import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useCallback } from 'react';
import { has, keys } from 'sdk';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import { Tooltip } from '../errorLabel';
import { commonStyles, Interface, useLogic } from './common';
import { MessageFieldButtonsChat } from './messageFieldButtons';
import { Suggestions } from './suggestions';
import { TextArea } from './textarea/textarea';

const Component = observer(
	({
		className,
		onSendClick: onSendClickProp,
		onChange: onChangeProp,
		value,
		onSuggestionSelect,
		error,
		disabled,
	}: Interface): ReactElement => {
		const { suggestionsStore } = useSDK();
		const { attachmentsInputRef, onKeyPress, onSendClick, onChange } = useLogic(
			onSendClickProp,
			false,
			onChangeProp,
			value
		);

		return (
			<>
				{(has(suggestionsStore.suggestions, value) &&
					keys(suggestionsStore.suggestions[value]).length &&
					onSuggestionSelect && (
						<Suggestions
							onSuggestionSelect={onSuggestionSelect}
							suggestions={suggestionsStore.suggestions[value]}
						/>
					)) ||
					null}
				<div>
					<div className={className}>
						{error && <Tooltip className="error-tooltip">{error}</Tooltip>}
						<MessageFieldButtonsChat
							inRow
							emojiPanelActive={false}
							onSendClick={disabled ? (): void => void 0 : onSendClick}
							onAttachmentClick={useCallback(
								() => attachmentsInputRef.current?.click(),
								[attachmentsInputRef]
							)}
							withAttachments={false}
							isInvolve
						>
							<TextArea onKeyPress={onKeyPress} onChange={onChange} value={value} />
						</MessageFieldButtonsChat>
					</div>
				</div>
			</>
		);
	}
);

const MessageFieldInvolve = styled(Component)(
	commonStyles,
	css`
		div&:focus-within {
			border-bottom: 0;
			border-left: 0;
			border-radius: 0;
			border-right: 0;
		}

		div& {
			border-bottom: 0;
			border-left: 0;
			border-radius: 0;
			border-right: 0;
			margin: 0;
			height: auto;

			textarea {
				padding-right: 8px;
			}
		}
	`
);

export { MessageFieldInvolve };
